import { useNavigate } from "react-router-dom";
import styles from "./footer.module.scss";

export default function Footer() {
  const navigate = useNavigate();

  const navigateToPolicy = () => {
    navigate("/policy");
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.topWrapper}>
            <div className={styles.left}>
              <div className={styles.leftTop}>
                <div>
                  <img
                    className={styles.logokriha}
                    src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/KRIHA_MEGAM_LOGO/krihaMegamLogo.png"
                    alt="img"
                  />
                </div>
                <p>
                  We will provide a server in your home our technical team will
                  come to your site and fix the server for your data.
                </p>
              </div>
              <div className={styles.leftBottom}>
                Copyright © 2025 Kriha. All Rights Reserved
              </div>
            </div>
            <div className={styles.center}>
              <div className={styles.centerLeft}>
                <h1>Menu</h1>
                <a href="#hero">Home</a>
                <p>Features</p>
                <p>Pricing</p>
                <a href="#contact">Contact Us</a>
              </div>
              <div className={styles.centerRight}>
                <h1>Info</h1>
                <p>Terms</p>
                <p onClick={navigateToPolicy}>Privacy Policy</p>
                <p>Support</p>
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.rightTop}>
                <h1>Follow us on</h1>
                <div className={styles.rightIcon}>
                  {/* <a className={styles.rightIconContainer}>
                    <img
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/facebookIcon.png"
                      alt="img"
                    />{" "}
                  </a> */}
                  <a
                    className={styles.rightIconContainer}
                    href="https://www.linkedin.com/posts/krihaitsolutions_websitedesign-teamwork-smallbusinesshelp-activity-7266151297689497600-2IAm"
                    target="_blank"
                  >
                    <img
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/linkedInIcon.png"
                      alt="img"
                    />{" "}
                  </a>
                  <a
                    className={styles.rightIconContainer}
                    href="https://www.youtube.com/@kriha-pay/videos"
                    target="_blank"
                  >
                    {" "}
                    <img
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/youtubeIcon.png"
                      alt="img"
                    />
                  </a>
                  {/* <div className={styles.rightIconContainer}>
                    <img
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/xIcon.png"
                      alt="img"
                    />
                  </div> */}
                  <a
                    className={styles.rightIconContainer}
                    href="https://www.instagram.com/krihaitsolutions/"
                    target="_blank"
                  >
                    {" "}
                    <img
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/instaIcon.png"
                      alt="img"
                    />{" "}
                  </a>
                  <a
                    className={styles.rightIconContainer}
                    href="https://wa.me/9677165660"
                    target="_blank"
                  >
                    {" "}
                    <img
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/whatsappIcon.png"
                      alt="img"
                    />{" "}
                  </a>
                </div>
              </div>
              <div className={styles.rightBottom}>
                Powered by{" "}
                <a href="https://www.krihaitsolutions.com/" target="_blank">
                  Kriha IT Solutions
                </a>
              </div>
            </div>
          </div>
          {/* <div className={styles.bottomMiddleBottom}>
            <div className={styles.wrapperMedia}>
              <div className={styles.contentMedia}>
                <div className={styles.wrapperBottomTop}>
                  <div className={styles.bottomTopImg}>
                    <img
                      className={styles.logoMedia}
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/KRIHA_MEGAM_LOGO/krihaMegamLogo.png"
                      alt="img"
                    />
                  </div>{" "}
                </div>
                <p>
                  We will provide a server in your home our technical team will
                  come to your site and fix the server for your data.
                </p>
              </div>
              <div className={styles.contentMedia4}>
                <div className={styles.logoHeaderBottom}>
                  <div className={styles.bottomTitleLogo}>
                    <h1>Follow us on</h1>{" "}
                  </div>
                </div>
                <div className={styles.iconMedia}>
                  <div className={styles.mediaLogoBottom}>
                    <img
                      className={styles.mediaLogoBottomImg}
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/facebookIcon.png"
                      alt="img"
                    />{" "}
                  </div>
                  <div className={styles.mediaLogoBottom}>
                    <img
                      className={styles.mediaLogoBottomImg}
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/linkedInIcon.png"
                      alt="img"
                    />{" "}
                  </div>
                  <div className={styles.mediaLogoBottom}>
                    {" "}
                    <img
                      className={styles.mediaLogoBottomImg}
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/youtubeIcon.png"
                      alt="img"
                    />
                  </div>
                  <div className={styles.mediaLogoBottom}>
                    <img
                      className={styles.mediaLogoBottomImg}
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/xIcon.png"
                      alt="img"
                    />
                  </div>
                  <div className={styles.mediaLogoBottom}>
                    {" "}
                    <img
                      className={styles.mediaLogoBottomImg}
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/instaIcon.png"
                      alt="img"
                    />{" "}
                  </div>
                  <div className={styles.mediaLogoBottom}>
                    {" "}
                    <img
                      className={styles.mediaLogoBottomImg}
                      src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/SOCIAL_MEDIA_ICONS/whatsappIcon.png"
                      alt="img"
                    />{" "}
                  </div>
                </div>
              </div>
              <div className={styles.bottomMiddile}>
                <div className={styles.contentMedia2}>
                  <h1>Menu</h1>
                  <p>Home</p>
                  <p>Features</p>
                  <p>Pricing</p>
                  <p>Contact Us</p>
                </div>
                <div className={styles.contentMedia3}>
                  <h1>Info</h1>
                  <p>Terms</p>
                  <p>Privacy Policy</p>
                  <p>Support</p>
                </div>
              </div>
            </div>
            <div className={styles.bottomCenterD}>
              {" "}
              <div className={styles.bottom}>
                <p>Copyright © 2025 Kriha. All Rights Reserved</p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}
